<h4 class="ds-heading-2" [class.ds-color-error]="hasError"
  >{{ title }}
  <app-ds-icon *ngIf="!!hint" class="info-icon" (click)="toggleHint()" name="info" color="var(--color-core-neutral-5)" />
</h4>
<div *ngIf="showHint" class="info-hint">
  <p class="ds-ui-3 ds-color-core-neutral-7">{{ hint }}</p>
</div>
<div class="question-row chips">
  <ng-container *ngFor="let option of options">
    <app-ds-chip [active]="value === option.id" [value]="option.id" (check)="onOptionChange($event, option)">
      {{ option.option_text }}
    </app-ds-chip>
  </ng-container>
  <ng-container *ngIf="shortHorizon">
    <app-ds-callout
      variant="warning"
      [title]="'GROW.riskProfile.profile.investmentPeriodCallout.heading' | translate"
      [description]="'GROW.riskProfile.profile.investmentPeriodCallout.description' | translate"
    ></app-ds-callout>

    <div class="increased-risk-bottom">
      <app-ds-checkbox
        [checkboxPosition]="'top'"
        [label]="'GROW.riskProfile.profile.investmentPeriodConsent' | translate"
        [checked]="acceptShortTerm"
        (clicked)="updateShortInvestment()"
        [hasError]="showShortHorizonError"
        [errorMessage]="'GROW.riskProfile.profile.investmentPeriodConsentError' | translate"
      ></app-ds-checkbox>
    </div>
  </ng-container>
</div>
